/**
 * Callback Ref to use in apps to then pass onto DOM components to show if
 * app has been hydrated or not - useful for waiting in e2e tests or showing
 * information in development mode.
 */
export const isHydratedRef = (node: HTMLElement | null) => {
  node?.setAttribute('data-hydrated', 'true');

  return function cleanup() {
    node?.removeAttribute('data-hydrated');
  };
};
